// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type PersonalizationOptionCard_CheckoutConfigOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, cutoffDate?: Types.Scalars['Date']['input'] | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, marketingDescription?: string | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string, name: string } }> };

export const PersonalizationOptionCard_CheckoutConfigOptionGroupFragmentDoc = gql`
    fragment PersonalizationOptionCard_CheckoutConfigOptionGroup on CheckoutConfigOptionGroup {
  id
  cutoffDate
  group {
    id
    name
    marketingDescription
  }
  options {
    id
    option {
      id
      name
    }
  }
}
    `;